import { render } from "./Loader.vue?vue&type=template&id=9480fbc8"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=9480fbc8&lang=scss"
script.render = render

export default script